import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Icon, Spinner } from '@components';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import { useSendManualPaymentLinkCustomTermMutation } from '@features/group-management/queries/GroupQuery';
import useNotify from '@hooks/notify';
import { ApiError } from '@types';
import { getLocalStorageItem } from '@utils/storage';

import theme from '../../../../../themes/colors';

const SendTermPaymentLinkAction = ({
  memberId,
  canSendPaymentLink
}: {
  memberId: string;
  canSendPaymentLink: boolean;
}) => {
  const { groupId } = useParams();
  const [isLinkSent, setIsLinkSent] = useState(false);
  const { createErrorAlert } = useNotify();

  const [sendManualPaymentLinkCustomTerm, { isLoading: isSendingLink }] =
    useSendManualPaymentLinkCustomTermMutation();

  const handleSendPaymentLink = async () => {
    const res = await sendManualPaymentLinkCustomTerm({
      params: {
        organizationId: getLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_ID),
        branchId: getLocalStorageItem(LOCAL_STORAGE_KEYS.BRANCH_ID),
        groupId: groupId ?? '',
        memberId
      }
    });
    if ('data' in res) {
      setIsLinkSent(true);
    } else if ('error' in res) {
      const apiError = res.error as ApiError;
      createErrorAlert(
        apiError.data?.message || 'Error in fetching member data'
      );
    }
  };

  if (isLinkSent) {
    return (
      <div className="ml-auto flex w-47 items-center justify-end gap-1">
        <Icon name="tick" stroke={theme.cofeePrimary7} />
        <span className="text-sm font-medium text-cofeeGreen7">
          Payment link sent
        </span>
      </div>
    );
  }

  if (!canSendPaymentLink) return null;

  if (isSendingLink) {
    return (
      <div className="ml-auto flex w-47 items-center justify-center">
        <Spinner className="size-4 border border-cofeePrimary6" />
        <span className="text-sm font-medium text-cofeePrimary6">
          Sending payment link
        </span>
      </div>
    );
  }

  return (
    <Button
      variant="secondary"
      size="small"
      leftIconName="send-link-green"
      label="Send payment link"
      labelStyle="!text-cofeePrimary6 !text-sm !font-medium !text-center !align-middle"
      className="ml-auto h-9 w-47"
      handleClick={handleSendPaymentLink}
    />
  );
};

export default SendTermPaymentLinkAction;
